import React from "react";
import Team from "../assets/team.jpeg"
import './ServiceBanner.css';
import { Link } from "react-router-dom";




function ServiceBanner() {
  

  return (
    <section className="services-hero">



      <img src={Team}   alt='Service Banner'  className=' services-hero-img' />

      <div className="services-overlay"></div>

      <div className="services-content">
      <h1> Get Your Perfect Plan</h1>

      <p>Driving Digital Growth Through <br/> Smart IT Solutions</p>


        <Link to="/contact" className="call-btn">
           Request A Call
        </Link>
       
       </div>
    </section>
  );
}

export default ServiceBanner;